import Select from '@components/Select'
import styles from '../styles.module.scss'

export const FilterControlMenu = ({ filterOptions, ratingOptions, filterRating, setFilterRating }) => (
    <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex">
            <Select
                className={styles.filterType}
                options={filterOptions}
                getOptionLabel={opt => opt}
                defaultValue={filterOptions[0]}
            />
            <Select
                className={styles.filterRating}
                options={ratingOptions}
                value={<span>{filterRating || '0'}</span>}
                getOptionValue={option => option}
                getOptionLabel={option => <span>{option}</span>}
                defaultValue="0"
                onChange={value => setFilterRating(value)}
            />
        </div>
        <h3>
            <T>nps.admin.dashboard.additional.feedback.rating.label</T>
        </h3>
    </div>
)
